import { Portfolio } from '~/stores/use-portfolio/usePortfolio';

export const getPortfolioName = (portfolio: Portfolio) =>
  portfolio.alias || portfolio.name || portfolio.external_id;
